export default __webpack_public_path__ + "static/media/favicon.078aa083.ico";